<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<rect x="7.75" y="10.75" width="28.5" height="22.5" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<path d="M19.7539 17.5547H24.2441V26.5352H19.7539V17.5547Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="12.8887" cy="15.6445" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="12.8887" cy="28.5156" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="31.2188" cy="15.6445" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="31.2188" cy="28.5156" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
